import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ConfigService } from 'src/app/services';

export enum Layout {
  inline = 'inline',
  navBelow = 'nav-below'
}

export enum Toggle {
  left = 'left',
  right = 'right'
}

export interface HeaderConfig {
  toggle?: Toggle;
  layout?: Layout;
  title?: string;
  classes?: string;
  wrapperClasses?: string;

}

const configNamespace = 'common.header',
  defaults: HeaderConfig = {
    layout: Layout.inline,
    classes: '',
    wrapperClasses: ''
  };

@Component({
  selector: 'app-cmn-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
  defaultConfig: HeaderConfig;
  @Input() config: HeaderConfig;
  public Toggle = Toggle;
  @Input() toggle: boolean;
  @Output() toggleChange = new EventEmitter<boolean>();
  @Input() titleRef: TemplateRef<any>;

  constructor(private el: ElementRef, @Optional() configService: ConfigService) {
    if (configService) {
      // Pull higher level title
      defaults.title = configService.get('title');
    }
    this.defaultConfig = ConfigService.SafeInit(configService, configNamespace, defaults);
  }

  doToggle() {
    this.toggle = !this.toggle;
    this.toggleChange.emit(this.toggle);
  }

  ngOnInit() {
    this.config = ConfigService.MergeDefaults(this.defaultConfig, this.config || {});
    this.el.nativeElement.classList.add(this.config.layout);
  }
}
